import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Row, Col, Table as TableRB } from 'react-bootstrap';
import {
  Table,
  Avatar,
  Space,
  Typography,
  Card,
  Button,
  Tooltip,
  Statistic,
  DatePicker,
  Select,
  Input,
} from 'antd';
import {
  UserAddOutlined,
  ReloadOutlined,
  UserDeleteOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import socketHandler from '../../config/socket';
import DepartmentFilter from '../../components/departmentFilter';
import ActivityFilter from './activityFilter';
import AddModal from './createTimesheet';
import {
  getDailyTimeSheets,
  getDateTimeSheets,
  getTimeSheetTotal,
} from '../../redux/timesheets/action';

import { countMembers } from '../../redux/members/action';
import {
  renderColumnAt,
  parseTimeSheets,
  generateExcelFileAttendace,
  formatTime,
  parseAttendanceTimeSheets,
} from './util';
import Item from './shiftlistItem';
import LeaveItem from './leaveListItem';
import { styles } from './style';
import TotalTimes from './totalTimes';
import UserDetailsModal from '../../components/userDetailsModal';
import AddAbsence from './addAbsence';

const { Text } = Typography;
const { Search } = Input;

const renderTitle = (title) => {
  return (
    <div>
      <Text strong className="d-block text-light">
        {title}
      </Text>
    </div>
  );
};

const renderTime = (time) => {
  return <Text>{formatTime(time)}</Text>;
};

const renderDate = (date) => {
  if (!date) {
    return <Text>-----</Text>;
  }
  return <Text>{moment(date).format('HH:mm:ss')}</Text>;
};

export default function Index() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { dailyLeaves, initialD, dailyAttendance } = useSelector(
    (state) => state.timesheetsReducer
  );
  const { company } = useSelector((state) => state.auth);
  const { allDeptByIds } = useSelector((state) => state.membersReducer);
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [show, setShow] = useState(false);
  const [totalTimes, setTotalTimes] = useState(null);
  const [selectedDpt, setDpt] = useState(null);
  const [activity, setActivity] = useState(null);
  const [date, setDate] = useState(moment().subtract(1, 'day'));
  const [absenceModal, setAbsenceModal] = useState(false);
  const [userDetailModal, setDetailModal] = useState(false);
  const [selectedUser, selectUser] = useState(null);
  const [total, SetTotal] = useState(0);
  const depRef = useRef(null);
  const actRef = useRef(null);
  const dateRef = useRef(null);
  const statusRef = useRef(null);

  const [status, setStatus] = useState('approved');
  const selectMode = (value) => {
    setStatus(value);
    statusRef.current = value;
    setLoader(true);
    dispatch(getDateTimeSheets(selectedDpt, activity, date, value, stopLoader));
  };

  const stopLoader = () => {
    setLoader(false);
  };
  const stopLoaderCount = (_total) => {
    SetTotal(_total);
  };
  useEffect(() => {
    if (initialD) {
      setLoader(true);
      dispatch(
        getDateTimeSheets(selectedDpt, activity, date, status, stopLoader)
      );
      dispatch(countMembers(selectedDpt, stopLoaderCount));
    }
  }, []);

  const timeSheetTotalCB = (success, data) => {
    if (success) {
      setTotalTimes(data);
    }
  };

  useEffect(() => {
    if (Array.isArray(dailyAttendance)) {
      const data = parseAttendanceTimeSheets(dailyAttendance, true, []);
      setData(data);
    }
  }, [dailyAttendance]);

  const refreshData = () => {
    setLoader(true);
    dispatch(
      getDateTimeSheets(selectedDpt, activity, date, status, stopLoader)
    );
    dispatch(countMembers(selectedDpt, stopLoaderCount));
  };

  const goDetails = (user) => {
    history.push(`/app/timesheets/${user.id}`);
  };

  const onChangeDept = (dept) => {
    setDpt(dept);
    depRef.current = dept;
    setLoader(true);
    dispatch(getDateTimeSheets(dept, activity, date, status, stopLoader));
    dispatch(countMembers(selectedDpt, stopLoaderCount));
  };

  const onChangeDate = (_date) => {
    if (_date == null) {
      return;
    }
    setDate(_date);
    dateRef.current = _date;
    setLoader(true);
    dispatch(
      getDateTimeSheets(selectedDpt, activity, _date, status, stopLoader)
    );
  };

  const onChangeActivity = (value) => {
    setActivity(value);
    actRef.current = value;
    setLoader(true);
    dispatch(getDateTimeSheets(selectedDpt, value, date, status, stopLoader));
  };

  const showModal = () => {
    setShow(true);
  };

  const closeModal = () => {
    setShow(false);
  };

  const onSearch = (value) => {};

  const onRowAvatar = (record) => {
    const deptName = allDeptByIds?.[record?.organization]?.name || '';
    const userRecord = {
      ...record,
      company: company?.name,
      organization: deptName,
    };

    selectUser(userRecord);
    setDetailModal(true);
  };

  const fetchUpdates = useCallback((data) => {
    dispatch(
      getDateTimeSheets(
        depRef?.current,
        actRef?.current,
        dateRef.current,
        statusRef.current,
        () => {}
      )
    );
  }, []);

  useEffect(() => {
    socketHandler.on('timesheet', fetchUpdates);
    return () => {
      socketHandler.off('timesheet', fetchUpdates);
    };
  }, []);

  const renderAvatar = (user) => {
    if (user) {
      return (
        <Space align="center" className="c-pointer">
          <Avatar
            onClick={() => onRowAvatar(user)}
            style={styles.avatar}
            src={
              user?.profilePic ??
              'https://www.kindpng.com/picc/m/24-248253_user-profile-default-image-png-clipart-png-download.png'
            }
            size="medium"
          />
          <Text
            onClick={() => goDetails(user)}
            strong
            className="pl-2 font-weight-bold"
          >
            {user?.name?.split(' ')[0]}
          </Text>
        </Space>
      );
    }
  };

  const exportToExcel = () => {
    setLoader(true);

    const _data = data.map((x) => {
      return {
        'Employee Name': x.members.name,
        Department: allDeptByIds[x.members?.organization]?.name
          ? allDeptByIds[x.members?.organization]?.name
          : '',
        'Date In': moment(x.in).format('YYYY-MM-DD'),
        'Time In': moment(x.in).format('h:mm a'),
        'Latitude In': x.shifts[0].clockinCoord?.latitude
          ? x.shifts[0].clockinCoord.latitude
          : '--',
        'Longitude In': x.shifts[0].clockinCoord?.longitude
          ? x.shifts[0].clockinCoord.longitude
          : '--',
        'Date Out': x.out ? moment(x.out).format('YYYY-MM-DD') : '--',
        'Time Out': x.out ? moment(x.out).format('h:mm a') : '--',
        'Latitude Out': x.shifts[0].clockoutCoord?.latitude
          ? x.shifts[0].clockinCoord.latitude
          : '--',
        'Longitude Out': x.shifts[0].clockoutCoord?.longitude
          ? x.shifts[0].clockinCoord.longitude
          : '--',
        'Total Hours': x.out
          ? moment(x.out).diff(moment(x.in), 'hours') + ' HRS'
          : '--',
      };
    });
    generateExcelFileAttendace(_data, date);
    setLoader(false);
  };

  return (
    <React.Fragment>
      <Space className="mb-3 flex-wrap">
        <DepartmentFilter
          pickerStyle={{
            width: 215,
          }}
          onSelectDpt={onChangeDept}
        />

        <DatePicker onChange={onChangeDate} defaultValue={date} />
        <Search placeholder=" search by Name" onSearch={onSearch} enterButton />
        <Tooltip title="Fetch Latest Data">
          <Button onClick={refreshData}>
            <ReloadOutlined />
          </Button>
        </Tooltip>
        <Button
          type="primary"
          className="bg-primary border-primary "
          loading={loader}
          onClick={() => {
            exportToExcel();
          }}
        >
          Export to Excel
        </Button>
      </Space>

      <Row>
        <Col md={12}>
          <Row>
            <Card className="mb-3 mx-2">
              <Statistic
                title="Total Number of Present Members"
                value={data.length}
                valueStyle={{ color: '#3f8600' }}
                prefix={<UserAddOutlined />}
                suffix="Members"
              />
            </Card>

            {/* <Card className="mb-3 mx-2">
              <Statistic
                title="Total Number of Absent Members"
                value={'1'}
                valueStyle={{ color: '#FF0000' }}
                prefix={<UserDeleteOutlined />}
                suffix="Members"
              />
            </Card> */}

            {/* <Card className="mb-3 mx-2">
              <Statistic
                title="Total Number of members"
                value={total}
                valueStyle={{ color: '#f79425' }}
                prefix={<UserOutlined />}
                suffix="Members"
              />
            </Card> */}
          </Row>
        </Col>
        <Col md={12}>
          <Table
            className="table-curved"
            columns={renderColumnAt(
              renderTitle,
              renderAvatar,
              renderTime,
              renderDate
            )}
            dataSource={data}
            scroll={data.length > 0 && { x: true }}
            size="medium"
            pagination={true}
            loading={loader}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
}
